/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilekindplace2Inputs */

const en_profilekindplace2 = /** @type {(inputs: Profilekindplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place`)
};

const de_profilekindplace2 = /** @type {(inputs: Profilekindplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Place" |
*
* @param {Profilekindplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilekindplace2 = /** @type {((inputs?: Profilekindplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilekindplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilekindplace2(inputs)
	return de_profilekindplace2(inputs)
});
export { profilekindplace2 as "profileKindPlace" }